<template>
  <header v-if="selectedUserUnitId && Object.keys(userUnitsMap).length > 0 && !hideHeaderAndFooter" class="headerMenuArea">
    <!-- sidebar menu start -->
    <div class="sidebarMenuArea">
      <!--      <button type="button" @click="toggleSidebar">Sidebar'ı Aç</button>-->
      <transition :name="sidebarTransition">
        <!-- SidebarMenu bileşeni, v-if ile görünürlüğü kontrol edilir -->
        <sidebar-menu
          v-if="isOpenSidebar"
          :key="sidebarTransition"
          ref="sidebarMenu"
          :menu-items="menuItems"
          :page-permissions-map="pagePermissionsMap"
          @loadReport="loadReport($event)"
          @closeSideBar="closeSideBar()"
        />
      </transition>
    </div>

    <!-- sidebar menu end -->

    <!--header area start-->
    <section class="headerArea">
      <div class="container-fluid headerNav">
        <div class="row">
          <div class="col-auto col-lg-auto pr-0">
            <nav>
              <div class="nav">
                <button id="trigger" type="button" class="navbarButton menu-trigger" @click="toggleSidebar()">
                  <img src="../../../public/src/images/hamburger-menu-icon.svg" alt="header-menu-icon" />
                </button>

                <span class="headerDesktopImg" @click="$router.push('/')">
                  <img src="../../../public/src/images/tcdd-header-logo.svg" class="img-fluid" alt="tcdd-logo" />
                </span>
              </div>
            </nav>
          </div>
          <!-- header search start -->
          <div class="col col-lg px-0">
            <div class="input-group">
              <span class="headerMobilImg">
                <img src="../../../public/src/images/tcdd-header-logo.svg" class="img-fluid" alt="tcdd-header-logo" />
              </span>
              <div ref="searchMenuDropdownRef" class="dropdown headerSearchDropdown" @keydown="navigateDropdown($event)">
                <!-- YTP-10521 saf-Vue: data-toggle KALDIRILDI (input + buton). Bootstrap dropdown JS'i (Popper +
                     keydown yonetimi) prod'da Popper'i uygulamiyor + tusa basinca menuyu ac/kapa ettiriyordu.
                     Gorunurluk yalnizca Vue .show ile; konumlandirma acik CSS ile (header.scss). -->
                <input
                  v-model="searchQueryComputed"
                  class="form-control dropdown-toggle searchInput"
                  type="text"
                  role="combobox"
                  aria-haspopup="listbox"
                  :aria-expanded="searchMenuDropdownOpen ? 'true' : 'false'"
                  placeholder="İşlem yapmak istediğiniz kategoriyi yazınız."
                  aria-label="Search"
                  @click="searchMenuToggleDropdown"
                />
                <!-- mobil search button -->
                <button
                  type="button"
                  class="btn searchBtn form-control dropdown-toggle"
                  role="combobox"
                  aria-haspopup="listbox"
                  :aria-expanded="searchMenuDropdownOpen ? 'true' : 'false'"
                  @click="mobileSearchButton"
                />
                <div :class="{ show: searchMenuDropdownOpen }" class="dropdown-menu">
                  <!--<form>-->
                  <div class="headerSearchInput">
                    <div class="row">
                      <div class="col-12">
                        <input ref="mobileSearch" v-model="searchQueryComputed" class="form-control searchInputMobil" type="text" aria-label="Search" />
                      </div>
                    </div>

                    <!--favoriler start-->
                    <div v-show="serchArea" class="FavoriteTrades" @click="clickElementBody()">
                      <div class="row favoriteTradesRow">
                        <div class="col-12">
                          <h5 class="FavoriteTradesTitle">
                            <span>
                              <img src="../../../public/src/images/header-search-star.svg" alt="header-search-star" class="favStarGold" />
                            </span>
                            Favori işlemler
                          </h5>
                        </div>
                        <!--diziyi ikiye böldük htmle uydurmak için dizinin ilk yarısı burada-->
                        <div class="col-12 searchMenu">
                          <ul>
                            <template v-for="item in flatItems">
                              <li
                                v-if="item.route !== '' && isFav(item) && pagePermissionsMap[item.pagePermissionTag]"
                                :key="'favoriteMenu' + item.index"
                              >
                                <router-link
                                  v-if="!item.reportId"
                                  tag="a"
                                  :to="{ path: '/rapor-sayfasi/' + reverseReportMap[item.reportId] }"
                                  :active-class="'active'"
                                  exact
                                  @click.native="searchInputReset(item)"
                                >
                                  {{ item.name }}
                                </router-link>
                                <a
                                  v-else
                                  :id="'report-' + item.reportId"
                                  :href="'/rapor-sayfasi/' + reverseReportMap[item.reportId]"
                                  :class="'active'"
                                  @click="goToReportPage(item)"
                                >
                                  {{ item.name }}
                                </a>
                              </li>
                            </template>
                            <template v-if="hasFavoritesFlat() === false">Favorileriniz bulunmamaktadır.</template>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!--favoriler end-->

                    <!-- klavyeden herhangi bir tuşa basınca start -->
                    <div v-show="!serchArea" class="navbarSearch" @click="clickElementBody()">
                      <div class="row no-gutters">
                        <div class="col-12 searchMenu">
                          <ul>
                            <template v-for="item in flatItems">
                              <li
                                v-if="item.route !== '' && shouldShowItem(item) && pagePermissionsMap[item.pagePermissionTag]"
                                :key="'headerSearchMenu' + item.index"
                              >
                                <tooltips-component
                                  :ref="'headerSearchTooltip' + item.index"
                                  :tooltip-class="isFav(item) ? 'customTooltipRed' : 'customTooltip'"
                                  @clickEvent="(favoriteItem(item, $event), preventDropdownClose($event))"
                                />
                                <router-link
                                  v-if="!item.reportId"
                                  tag="a"
                                  :to="item.route"
                                  :active-class="'active'"
                                  exact
                                  @click.native="searchInputReset(item)"
                                >
                                  {{ item.name }}
                                </router-link>
                                <!--                                :href="'/rapor-sayfasi/' + reportMap[item.reportId]"-->

                                <a v-else :id="'report-' + item.reportId" :class="'active'" @click="goToReportPage(item)">
                                  {{ item.name }}
                                </a>
                              </li>
                            </template>
                            <template v-if="flatItems.length === 0">Aradığınız öge bulunamadı...</template>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- klavyeden herhangi bir tuşa basınca end -->
                  </div>
                  <!--</form>-->
                </div>
              </div>
            </div>
          </div>
          <!-- header search end -->

          <!-- header date time start -->
          <div class="col-auto col-lg-auto px-0">
            <div class="clockArea headerIcons">
              <p class="textDate">
                {{ todayDate() }}
              </p>
              <div class="textTime">
                <span class="text">
                  {{ time[0] + time[1] }}
                </span>
                <span class="textTwoDots">:</span>
                <span class="text">
                  {{ time[3] + time[4] }}
                </span>
              </div>
            </div>
          </div>
          <!-- header date time end -->
          <!-- header favorite start-->
          <div v-if="false" class="col-auto col-lg-auto px-0">
            <a href="#" class="headerIcons" data-toggle="modal" data-target="#favoriteModal">
              <img src="../../../public/src/images/icon-header-star.svg" class="img-fluid" alt="icon-star" />
              <span class="text">Favoriler</span>
            </a>
          </div>
          <!-- header favorite end-->
          <!-- header call center start -->
          <div class="col-auto col-lg-auto px-0">
            <a href="https://ebilet.tcddtasimacilik.gov.tr/cozum-merkezi" target="_blank" class="headerIcons">
              <img src="../../../public/src/images/icon-header-call-center.svg" class="img-fluid" alt="icon-header-call-center" />
              <span class="text">Çözüm Merkezi</span>
            </a>
          </div>
          <!-- header call center end -->

          <!-- header staff notifications history start -->
          <div class="col-auto col-lg-auto px-0">
            <a href="#" class="headerIcons" @click.prevent="openStaffNotificationHistory">
              <img src="../../../public/src/images/icon-header-bell.svg" class="img-fluid" alt="icon-header-bell" />
              <span class="text">Bilgilendirmeler</span>
            </a>
          </div>
          <!-- header staff notifications history end -->

          <!-- header checklist start -->
          <div v-if="false" class="col-auto col-lg-auto px-0">
            <a href="#" class="headerIcons">
              <span class="triangle">0</span>
              <img src="../../../public/src/images/icon-header-checklist.svg" class="img-fluid" alt="icon-header-checklist" />
              <span class="text">Görevler</span>
            </a>
          </div>
          <!-- header checklist end -->

          <!-- notification start -->
          <div v-if="false" class="col-auto col-lg-auto px-0">
            <a href="#" class="headerIcons" @click="openNotificationMenuModal()">
              <span class="triangle">{{ notifications.length }}</span>
              <img src="../../../public/src/images/icon-header-bell.svg" class="img-fluid" alt="icon-header-bell" />
              <span class="text">Bildirimler</span>
            </a>
          </div>
          <!-- notification end -->

          <!-- user information start -->
          <div class="col-auto px-0">
            <a href="#" class="userIcon" data-toggle="modal" data-target="#userMenuModal">
              <div class="row user no-gutters">
                <div class="col-12 d-flex align-items-center">
                  <img src="../../../public/src/images/icon-user-select.svg" class="img-fluid" alt="user" />
                  <span>{{ getUserName() }}</span>
                </div>
              </div>
            </a>
          </div>
          <!-- user information end -->
        </div>
      </div>
    </section>
    <!--header area end-->

    <!--Ucid start-->
    <section v-if="pagePermissionsMap['crs/rail-ivr/transfer-agent-call']" class="ucidArea">
      <div class="ucidCode" :style="{ height: $store.getters.getCallCenterUCId ? 'auto' : '30px' }">
        <img src="../../../public/src/images/icon-white-phone-gif.gif" alt="icon-white-phone-gif.gif" />
        <span class="text">
          {{ $store.getters.getCallCenterUCId ? `ÇAĞRI NUMARASI : ${$store.getters.getCallCenterUCId}` : "ÇAĞRI NUMARASI YOK." }}
        </span>
      </div>
    </section>
    <!--Ucid end-->

    <!-- favorite modal start-->
    <div id="favoriteModal" class="modal fade righToLeftModal" tabindex="-1" aria-labelledby="favoriteModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="notificationArea">
              <div class="row justify-content-between">
                <div class="col-auto">
                  <h5>Favoriler</h5>
                </div>
                <div class="col-auto">
                  <button type="button" class="close closebtn" aria-label="Close" data-dismiss="modal">
                    <span aria-hidden="true">
                      <img src="../../../public/src/images/sidebar-menu-close.svg" alt="sidebar-menu-close" />
                    </span>
                  </button>
                </div>
              </div>
              <div class="row">
                <!--eğer hiç bir favori yoksa tümünü sil gözükmeyecek start-->
                <div class="col-12">
                  <button type="button" href="#" class="notificationDelete">Tümünü Kaldır</button>
                </div>
                <!--eğer hiç bir favori yoksa tümünü sil gözükmeyecek end-->
                <div class="col-12">
                  <ul class="notificationNav favoriteArea">
                    <!-- eğer favori yoksa gözükecek alan start-->
                    <!--<li class="nav-item">-->
                    <!--  <a href="#" class="nav-link">-->
                    <!--    <div class="row">-->
                    <!--      <div class="col-12 text-center">-->
                    <!--        <p class="textEmpty">Favorileriniz bulunmamaktadır.</p>-->
                    <!--      </div>-->
                    <!--    </div>-->
                    <!--  </a>-->
                    <!--</li>-->
                    <!-- eğer favori yoksa gözükecek alan end-->
                    <li class="nav-item">
                      <a href="#" class="nav-link">
                        <div class="row align-items-center">
                          <div class="col-auto d-inline-flex">
                            <tooltips-component
                              :tooltip-img="true"
                              :tooltip-btn-img="'icon-star-yellow.svg'"
                              :tooltip-class="'p-0 d-inline-flex'"
                              :tooltip-title="'Favorilerden Çıkar'"
                            />
                          </div>
                          <div class="col-9 px-0">
                            <p>Askeri İşlemleri</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#" class="nav-link">
                        <div class="row align-items-center">
                          <div class="col-auto d-inline-flex">
                            <tooltips-component
                              :tooltip-img="true"
                              :tooltip-btn-img="'icon-star-yellow.svg'"
                              :tooltip-class="'p-0 d-inline-flex'"
                              :tooltip-title="'Favorilerden Çıkar'"
                            />
                          </div>
                          <div class="col-9 px-0">
                            <p>Yönetici İşlemleri</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#" class="nav-link">
                        <div class="row align-items-center">
                          <div class="col-auto d-inline-flex">
                            <tooltips-component
                              :tooltip-img="true"
                              :tooltip-btn-img="'icon-star-yellow.svg'"
                              :tooltip-class="'p-0 d-inline-flex'"
                              :tooltip-title="'Favorilerden Çıkar'"
                            />
                          </div>
                          <div class="col-9 px-0">
                            <p>Satış İşlemleri</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#" class="nav-link">
                        <div class="row align-items-center">
                          <div class="col-auto d-inline-flex">
                            <tooltips-component
                              :tooltip-img="true"
                              :tooltip-btn-img="'icon-star-yellow.svg'"
                              :tooltip-class="'p-0 d-inline-flex'"
                              :tooltip-title="'Favorilerden Çıkar'"
                            />
                          </div>
                          <div class="col-9 px-0">
                            <p>Birim-Personel İşlemleri</p>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- favorite modal end-->
    <!-- notification menu modal start-->
    <div id="notificationMenuModal" class="modal fade righToLeftModal" tabindex="-1" aria-labelledby="notificationMenuModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="notificationArea">
              <div class="row justify-content-between">
                <div class="col-auto">
                  <h5>Bildirim</h5>
                </div>
                <div class="col-auto">
                  <button type="button" class="close closebtn" aria-label="Close" data-dismiss="modal">
                    <span aria-hidden="true">
                      <img src="../../../public/src/images/sidebar-menu-close.svg" alt="sidebar-menu-close" />
                    </span>
                  </button>
                </div>
              </div>
              <div class="row">
                <!--eğer hiç bir bildirim yoksa tümünü sil gözükmeyecek start-->
                <div v-show="notifications.length > 0" class="col-12">
                  <button type="button" href="#" class="notificationDelete" @click="deleteAllNotifications()">Tümünü Sil</button>
                </div>
                <!--eğer hiç bir bildirim yoksa tümünü sil gözükmeyecek end-->
                <div class="col-12">
                  <ul class="notificationNav">
                    <!-- eğer bildirim yoksa gözükecek alan start-->
                    <li v-if="notifications.length === 0" class="nav-item">
                      <a href="#" class="nav-link">
                        <div class="row">
                          <div class="col-12 text-center">
                            <p class="textEmpty">Bildiriminiz bulunmamaktadır.</p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <!-- eğer bildirim yoksa gözükecek alan end-->
                    <template v-for="(notification, notificationIndex) in notifications">
                      <li
                        v-if="notifications.length > 0"
                        :key="'notification-' + notificationIndex"
                        class="nav-item"
                        @click="handleNotificationClick(notification)"
                      >
                        <a href="#" class="nav-link">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <span class="notificationCircle high">Yİ</span>
                            </div>
                            <div class="col-9 pr-0">
                              <h5>
                                ({{ notification.channelName }}) {{ notification.subject === "Station" ? "İstasyon" : "İşlem" }}
                                {{ notification.detail === "new" ? "eklendi" : "değişti" }}
                              </h5>
                              <p v-if="notification.detail === 'new'" class="text-wrap">
                                {{
                                  `${notification.channelName} tarafında yeni bir istasyon eklendi. :
                                    ${notification.extra2} - ${notification.extra1}`
                                }}
                              </p>
                              <p v-else-if="notification.detail === 'change'" class="text-wrap">
                                {{
                                  `${notification.channelName} tarafında istasyonda değişiklik oldu. :
                                    ${notification.extra2} - ${notification.extra1}`
                                }}
                              </p>
                            </div>
                          </div>
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- notification menu modal end-->
    <!--  user menu modal start-->
    <div id="userMenuModal" class="modal fade righToLeftModal" tabindex="-1" aria-labelledby="userMenuModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="userArea">
              <div class="row">
                <div class="col-12">
                  <button type="button" class="close closebtn" aria-label="Close" data-toggle="modal" data-target="#userMenuModal">
                    <span aria-hidden="true">
                      <img src="../../../public/src/images/sidebar-menu-close.svg" alt="sidebar-menu-close" />
                    </span>
                  </button>
                </div>

                <div class="col-12">
                  <div class="userInformation">
                    <div class="row customRow15">
                      <div class="col-auto customPadding15">
                        <div class="userImgArea">
                          <img src="../../../public/src/images/icon-user-empty.svg" alt="icon-user-empty" />
                        </div>
                      </div>
                      <div class="col customPadding15 text-left">
                        <h5>{{ getFullName() }}</h5>
                        <div class="unitInfoArea">
                          <div class="row customRow15">
                            <div class="col-auto customPadding15">
                              <p class="textGrey">Aktif Görev Yeri</p>
                            </div>
                            <div class="col-auto customPadding15">
                              <b-dropdown class="dropdownCheck" right variant="link">
                                <template #button-content>
                                  <img src="../../../public/src/images/icon-edit-success.svg" alt="icon-edit-success" />
                                  Değiştir
                                </template>
                                <b-dropdown-item-button
                                  v-for="userUnit in userUnits"
                                  :key="'userUnit-' + userUnit.id"
                                  :active="activeDropdownUnitItemClass(userUnit)"
                                  @click="activeDropdownUnitItem(userUnit)"
                                >
                                  {{ userUnit.name }}
                                </b-dropdown-item-button>
                              </b-dropdown>
                            </div>
                            <div v-if="Object.keys(userUnitsMap).length > 0" class="col-12 customPadding15">
                              <!--                              <p class="textUnitName">{{selectedUserUnit.name}}</p>-->
                              <p v-if="userUnitsMap[selectedUserUnitId]" class="textUnitName">{{ userUnitsMap[selectedUserUnitId].name }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--  -->
                    <div class="row customRow8 taskArea">
                      <div class="col-12 customPadding8">
                        <p class="textHead">
                          <img src="../../../public/src/images/icon-check-circle-corrugated-success.svg" alt="icon-check-circle-corrugated-success" />
                          Görevi
                        </p>
                      </div>
                      <div class="col-6 customPadding8">
                        <p v-if="userUnitsMap[selectedUserUnitId]" class="text">
                          <img src="../../../public/src/images/icon-check-grey.svg" alt="icon-check-grey" />
                          {{ selectedUserUnits(userUnitsMap[selectedUserUnitId].unitType) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <ul class="userNav">
                    <li class="nav-item">
                      <a href="#" class="nav-link" @click="fetchServisCheck()">
                        <i class="fas fa-sync-alt sync-alt-icon" />
                        Servis Durumları
                      </a>
                      <transition name="slide-fade">
                        <div v-if="servisCheckStatus" class="row slide-fade-container nav-link">
                          <div class="col-12 pb-1">
                            <span
                              class="status-circle"
                              :class="servisCheck.mernisStatus === null ? 'bg-gray' : servisCheck.mernisStatus === true ? 'bg-green' : 'bg-red'"
                            >
                              <i
                                class="fas"
                                :class="servisCheck.mernisStatus === null ? 'fa-ellipsis-h' : servisCheck.mernisStatus === true ? 'fa-check' : 'fa-times'"
                              ></i>
                            </span>
                            KİMLİK DOĞRULAMA
                          </div>
                          <div class="col-12 pb-1">
                            <span
                              class="status-circle"
                              :class="servisCheck.disabledCardStatus === null ? 'bg-gray' : servisCheck.disabledCardStatus === true ? 'bg-green' : 'bg-red'"
                            >
                              <i
                                class="fas"
                                :class="
                                  servisCheck.disabledCardStatus === null ? 'fa-ellipsis-h' : servisCheck.disabledCardStatus === true ? 'fa-check' : 'fa-times'
                                "
                              ></i>
                            </span>
                            AİLE BAKANLIĞI
                          </div>
                          <div class="col-12 pb-1">
                            <span
                              class="status-circle"
                              :class="servisCheck.kkyTasimacilikStatus === null ? 'bg-gray' : servisCheck.kkyTasimacilikStatus === true ? 'bg-green' : 'bg-red'"
                            >
                              <i
                                class="fas"
                                :class="
                                  servisCheck.kkyTasimacilikStatus === null
                                    ? 'fa-ellipsis-h'
                                    : servisCheck.kkyTasimacilikStatus === true
                                      ? 'fa-check'
                                      : 'fa-times'
                                "
                              ></i>
                            </span>
                            TAŞIMACILIK KKY
                          </div>
                          <div class="col-12">
                            <span
                              class="status-circle"
                              :class="servisCheck.kkyAltyapiStatus === null ? 'bg-gray' : servisCheck.kkyAltyapiStatus === true ? 'bg-green' : 'bg-red'"
                            >
                              <i
                                class="fas"
                                :class="
                                  servisCheck.kkyAltyapiStatus === null ? 'fa-ellipsis-h' : servisCheck.kkyAltyapiStatus === true ? 'fa-check' : 'fa-times'
                                "
                              ></i>
                            </span>
                            ALTYAPI KKY
                          </div>
                        </div>
                      </transition>
                    </li>
                    <li class="nav-item">
                      <a href="#" class="nav-link" @click="fetchPriceExchangeWithMultiplier()">
                        <i class="fas fa-wallet sync-alt-icon" />
                        Döviz Kuru
                        <span v-if="getPriceExchangeWithMultiplierStatus">-{{ priceExchangeWithMultipliers.formattedDate }}</span>
                      </a>
                      <transition name="slide-fade">
                        <div v-if="getPriceExchangeWithMultiplierStatus" class="row slide-fade-container nav-link">
                          <div class="col-12 pb-1">
                            <span class="status-circle bg-green">
                              <i class="fas fa-check"></i>
                            </span>
                            <span>
                              Alış =
                              <strong>{{ priceExchangeWithMultipliers.buyAmount }}</strong>
                            </span>
                            <span class="ml-1">
                              Satış =
                              <strong>{{ priceExchangeWithMultipliers.sellAmount }}</strong>
                            </span>
                          </div>
                        </div>
                      </transition>
                    </li>
                    <li v-if="false" class="nav-item">
                      <a href="#" class="nav-link">
                        <img src="../../../public/src/images/icon-header-user.svg" alt="icon-header-user" />
                        Hesabım
                      </a>
                    </li>
                    <li v-if="false" class="nav-item">
                      <a href="#" class="nav-link">
                        <img src="../../../public/src/images/icon-header-message.svg" alt="icon-header-message" />
                        Mesajlarım
                      </a>
                    </li>
                    <li v-if="false" class="nav-item">
                      <a href="#" class="nav-link">
                        <img src="../../../public/src/images/icon-user-header-checklist.svg" alt="icon-user-header-checklist" />
                        Görevlerim
                      </a>
                    </li>
                    <li v-if="false" class="nav-item">
                      <a href="#" class="nav-link">
                        <img src="../../../public/src/images/icon-header-star.svg" alt="icon-header-star" />
                        Favori İşlemlerim
                      </a>
                    </li>
                    <li v-if="false" class="nav-item">
                      <a href="#" class="nav-link">
                        <img src="../../../public/src/images/icon-header-settings.svg" alt="icon-header-settings" />
                        Ayarlar
                      </a>
                    </li>
                    <li class="nav-item" @click="logOut()">
                      <a href="#" class="nav-link">
                        <img src="../../../public/src/images/icon-header-log-out.svg" alt="icon-header-log-out" />
                        Çıkış
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  user menu modal end-->
    <loading :active.sync="loadingFullPage" :is-full-page="true" />
    <base-alert />
    <staff-notification-modal :notifications="staffNotifications" @allMandatoryConfirmed="onStaffNotificationsCompleted" />
    <staff-notification-history-modal ref="staffNotificationHistoryModal" @open-notification="openStaffNotificationFromHistory" />
  </header>
</template>

<script>
import { canCreatePage } from "../../util/pagePermissions";
import TooltipsComponent from "../element/TooltipsComponent.vue";
import { reportMap } from "../../util/reportMap";
import { reverseReportMap } from "../../util/reportMap";
import moment from "moment";
import Loading from "vue-loading-overlay";
import Vue from "vue";
import enumHelper from "../../util/enumHelper";
import BaseAlert from "../element/BaseAlert.vue";
import ServiceResponseHelper from "../../mixins/serviceResponseHelper";
import axios from "axios";
import resourceHelper from "../../util/resourceHelper";
import { clearAuthTokens } from "../../util/authTokenStorage";
import _ from "lodash";
import { store } from "../../store/store";
import SidebarMenu from "../SidebarMenu.vue";
import StaffNotificationModal from "../notification/StaffNotificationModal.vue";
import StaffNotificationHistoryModal from "../notification/StaffNotificationHistoryModal.vue";

export default {
  name: "BaseHeader",
  components: { SidebarMenu, TooltipsComponent, Loading, BaseAlert, StaffNotificationModal, StaffNotificationHistoryModal },
  mixins: [ServiceResponseHelper],
  data() {
    return {
      menuItems: Object.values(enumHelper.MyPages).filter((item) => {
        if (__ENVIRONMENT__ === "tcddprod" || __ENVIRONMENT__ === "tcdduat") {
          return item.name !== "İnterrail İşlemleri"; // TYTP-1309: eski hali "İnterrail/Eurail İşlemleri"
        }
        return true;
      }),
      interval: null,
      intervalSystemClock: null,
      notificationInterval: null,
      staffNotificationInterval: null,
      time: [],
      serchArea: true,
      notifications: [],
      staffNotifications: [],
      loadingKKYStationByStationNo: false,
      loadingSamePage: false,
      // items
      filteredItems: [],
      originalItems: [],
      // search
      searchQuery: "",
      pagePermissionsMap: {},
      userUnits: [],
      // selectedUserUnit: null,
      selectedUnitId: null,
      loadingAuthorizeByUnit: false,
      searchMenuDropdownOpen: false,
      // YTP-10521 mobil arama (searchBtn) breakpoint'i; .show'u yalnizca mobilde Vue verir
      isMobileSearch: false,
      userUnitsMap: {},
      selectedUserUnitTypeName: null,
      loadingParametersByUnit: false,
      loadingServisCheck: false,
      servisCheckStatus: false,
      servisCheck: {
        mernisStatus: null,
        disabledCardStatus: null,
        kkyTasimacilikStatus: null,
        kkyAltyapiStatus: null,
      },
      isOpenSidebar: false,
      sidebarTransition: "slide-forward",
      sideBarMenuClickedInside: false,
      environment: __ENVIRONMENT__,
      priceExchangeWithMultipliers: [],
      loadingGetPriceExchangeWithMultiplier: false,
      getPriceExchangeWithMultiplierStatus: false,
    };
  },
  computed: {
    reverseReportMap() {
      return reverseReportMap;
    },
    loggedIn: {
      get() {
        return this.$store.getters.getLoggedIn;
      },
      set(val) {
        this.$store.commit("setLoggedIn", val);
      },
    },
    lastOpenedSideBarContent: {
      get() {
        return this.$store.getters.getLastOpenedSideBarContent;
      },
      set(val) {
        this.$store.commit("setLastOpenedSideBarContent", val);
      },
    },
    filteredItemsSearch() {
      return this.filteredItems.filter((item) => {
        if (!item) {
          return false; // Ana öğe tanımlı değilse, false döndür
        }

        const itemName = item.name || ""; // Ana öğe adını al, eğer tanımlı değilse boş bir dizi dön

        // Hem ana öğeleri hem de alt öğeleri ara
        if (itemName.toLocaleLowerCase("tr-TR").includes(this.searchQuery.toLocaleLowerCase("tr-TR"))) {
          return true; // Ana öğe adı varsa
        }

        if (item.children && Array.isArray(item.children)) {
          return item.children.some((child) => {
            if (!child || !child.name) {
              return false; // Alt öğe tanımlı değilse veya alt öğe adı tanımlı değilse
            }
            return child.name.toLocaleLowerCase("tr-TR").includes(this.searchQuery.toLocaleLowerCase("tr-TR")); // Alt öğe adı varsa
          });
        }

        return false; // Eşleşen bir öğe yoksa
      });
    },
    hasFavorites() {
      // YTP-10380: favoriler store'da; yetkili en az bir favori var mi
      return (this.$store.getters.getUiFavorites || []).some((f) => this.pagePermissionsMap[f.tag]);
    },
    flatItems() {
      return this.flattenTree(this.filteredItems);
    },
    isOpenAccount: {
      get() {
        return this.$store.getters.getIsOpenAccount;
      },
      set(val) {
        this.$store.commit("setIsOpenAccount", val);
      },
    },
    loadingFullPage() {
      return (
        this.loadingAuthorizeByUnit ||
        this.loadingKKYStationByStationNo ||
        this.loadingParametersByUnit ||
        this.loadingSamePage ||
        this.loadingGetNotifications ||
        this.loadingDeleteUserNotification ||
        this.loadingSystemDateNow ||
        this.loadingReport ||
        this.loadingReportPage ||
        this.loadingCheckOpenAccount ||
        this.loadingServisCheck ||
        this.loadingGetPriceExchangeWithMultiplier
      );
    },
    searchQueryComputed: {
      get() {
        return this.searchQuery;
      },
      set(value) {
        this.searchQuery = value;
        // YTP-10541: dropdown gorunurlugu yalnizca Vue .show (searchMenuDropdownOpen) ile yonetilir.
        // Eski Bootstrap $(...).dropdown("toggle") cagrisi kaldirildi; her tus vurusunda Vue .show ile
        // cakisip menuyu kilitliyordu (sayfa secip tekrar arayinca dropdown kapanmiyordu).
        if (value !== "") {
          this.searchMenuDropdownOpen = true;
        }
      },
    },
    midnightRefreshFlag: {
      get() {
        return this.$store.getters.getMidnightRefreshFlag;
      },
      set(val) {
        this.$store.commit("setMidnightRefreshFlag", val);
      },
    },
    selectedUserUnitId: {
      get() {
        return this.$store.getters.getSelectedUserUnitId;
      },
      set(val) {
        this.$store.commit("setSelectedUserUnitId", val);
      },
    },
    hideHeaderAndFooter: {
      get() {
        if (this.$route.meta.hideHeaderAndFooter) {
          return this.$route.meta.hideHeaderAndFooter;
        } else {
          return false;
        }
      },
      set(val) {
        val = false;
      },
    },
    systemDateNow: {
      get() {
        return this.$store.getters.getSystemDateNow;
      },
      set(val) {
        this.$store.commit("setSystemDateNow", val);
      },
    },
    lastActivityTime: {
      get() {
        return this.$store.getters.getLastActivityTime;
      },
      set(val) {
        this.$store.commit("setLastActivityTime", val);
      },
    },
    idleTimeInMinutes: {
      get() {
        return this.$store.getters.getIdleTimeInMinutes;
      },
      set(val) {
        this.$store.commit("setIdleTimeInMinutes", val);
      },
    },
  },
  created() {
    if (!this.selectedUserUnitId) {
      this.logOut();
    }
    this.allMenuList();
    this.originalItems = JSON.parse(JSON.stringify(this.flatItems));
    this.createdFunction();
    this.fetchSystemClock();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.notificationInterval);
    clearInterval(this.staffNotificationInterval);
    document.removeEventListener("click", this.searchMenuDropdownHandleClickOutside);
    // YTP-10521 mobil arama breakpoint dinleyicisini temizle
    if (this._mobileSearchMq) {
      this._mobileSearchMq.removeEventListener
        ? this._mobileSearchMq.removeEventListener("change", this.updateMobileSearch)
        : this._mobileSearchMq.removeListener(this.updateMobileSearch);
    }
    clearInterval(this.intervalSystemClock);
    // Bileşen yok edilmeden önce dinleyicileri temizleyin (eklenen fonksiyonun kendisiyle; aksi halde kaldırılmaz)
    if (this._activityHandler) {
      window.removeEventListener("mousemove", this._activityHandler);
      window.removeEventListener("keydown", this._activityHandler);
      window.removeEventListener("click", this._activityHandler);
      this._activityHandler.cancel();
    }
    document.removeEventListener("click", this._dropdownActiveClassHandler);
    document.removeEventListener("keydown", this._dropdownMenuScrollHandler);
    document.removeEventListener("mousedown", this.handleMouseDownSideBarMenu);
    document.removeEventListener("click", this.handleClickOutsideSideBarMenu);
  },
  beforeMount() {
    this.setTitlesBasedOnPermissions();
    resourceHelper.setLoggedInUserMenuResources(enumHelper.allMenuTree, this.pagePermissionsMap);
  },
  mounted() {
    // YTP-10521 mobil arama breakpoint'ini izle (searchBtn <=576px'te gorunur)
    this._mobileSearchMq = window.matchMedia ? window.matchMedia("(max-width: 576px)") : null;
    this.updateMobileSearch();
    if (this._mobileSearchMq) {
      this._mobileSearchMq.addEventListener
        ? this._mobileSearchMq.addEventListener("change", this.updateMobileSearch)
        : this._mobileSearchMq.addListener(this.updateMobileSearch);
    }
    this.dropdownMenuScroll();
    this.removeDropdownActiveClass();
    this.dropdownMenuOpen();
    this.sidebarMenuCloseButton();

    document.addEventListener("click", this.handleClickOutsideSideBarMenu);
    document.addEventListener("mousedown", this.handleMouseDownSideBarMenu);

    this.hasFavoritesFlat();
    // YTP-10380: favoriler store'dan gelir; henuz yuklenmediyse yukle
    if (!this.$store.getters.isUiSettingsLoaded) {
      this.$store.dispatch("loadUiSettings");
    }
    document.addEventListener("click", this.searchMenuDropdownHandleClickOutside);
    if (Object.keys(this.userUnitsMap).length === 0 || !this.selectedUserUnitId) {
      this.logOut();
    }

    // Sekme görünürlük değişikliğini dinleyin
    // document.addEventListener('visibilitychange', this.handleVisibilityChange);
    // setLastActivityTime tüm sekmelere yayılır; oturum sınırı dakikalarla ölçüldüğü için 5 sn hassasiyet yeterli.
    this._activityHandler = _.throttle((event) => {
      this.resetIdleTimer();
    }, 5000);
    // Kullanıcı etkileşimlerini dinleyin ve zamanlayıcıyı sıfırlayın
    window.addEventListener("mousemove", this._activityHandler);
    window.addEventListener("keydown", this._activityHandler);
    window.addEventListener("click", this._activityHandler);

    this.time = this.systemDateNow
      ? moment(this.systemDateNow).format("HH:mm")
      : moment(this.$store.getters.getSystemDateNow ? new Date(this.$store.getters.getSystemDateNow) : new Date()).format("HH:mm");
    this.interval = setInterval(() => {
      this.time = this.systemDateNow
        ? moment(this.systemDateNow).format("HH:mm")
        : moment(this.$store.getters.getSystemDateNow ? new Date(this.$store.getters.getSystemDateNow) : new Date()).format("HH:mm");
      //let isItIdle =
      //  new Date(new Date(this.lastActivityTime).setMinutes(new Date(this.lastActivityTime).getMinutes() + this.idleTimeInMinutes)).getTime() <
      //  new Date().getTime();
      let idleSecondLimit = 600;
      const getUser = this.$store.getters.getUser;
      const userUnits = getUser && getUser.userUnits;
      const selectedUserUnitId = this.$store.getters.getSelectedUserUnitId;

      if (userUnits && selectedUserUnitId && userUnits.find((unit) => unit.id === selectedUserUnitId)?.unitType === "CALL_CENTER") {
        idleSecondLimit = 36000;
      } else if (this.environment === "uat" || this.environment === "dev") {
        idleSecondLimit = 1800; // 30 dakika
      }

      let isItIdle =
        new Date(new Date(this.lastActivityTime).setSeconds(new Date(this.lastActivityTime).getSeconds() + idleSecondLimit)).getTime() < new Date().getTime();
      if ((this.time === "00:00" && this.midnightRefreshFlag) || (isItIdle && this.loggedIn) || !this.loggedIn) {
        this.midnightRefreshFlag = false;
        this.callAlert(6, "Oturumunuz Sonlanmıştır. Tekrar giriş yapabilirsiniz.", "warning", "Oturum Sonlandı", "warning");
        this.logOut();
      } else if (this.time !== "00:00") {
        this.midnightRefreshFlag = true;
      }
      this.systemDateNow = new Date(new Date(this.$store.getters.getTimeBetweenSystemAndLocalTime).getTime() + new Date().getTime());
    }, 1000);

    if (window.location.origin + "/401" !== window.location.href) {
      //her bir dakikada bir bildirimleri kontrol ediyoruz

      //fixme bildirimler back-end tarafından gelene kadar kapatıldı

      this.notificationInterval = setInterval(() => {
        if (this.$store.getters.getLoggedIn) {
          // fetchNotifications geçici olarak durduruldu - /mc/notifications isteği atılmasın
          // this.fetchNotifications();
        }
      }, 60000);
      this.staffNotificationInterval = setInterval(() => {
        if (this.$store.getters.getLoggedIn) {
          this.fetchStaffNotifications();
        }
      }, 180000);
      // Login sonrası ilk kontrol için interval (3 dk) beklenmez.
      // getLoggedIn login akışında navigasyondan sonra (.finally) commit edildiğinden
      // burada henüz false olabilir; BaseHeader yalnızca oturum açıkken render edildiği için
      // doğrudan çağırıyoruz (store action zaten unitId yoksa no-op yapar).
      this.fetchStaffNotifications();
    }

    // Başlangıçta zamanlayıcıyı başlatın

    if (this.$store.getters.isCallCenterShowUCIdAlert) {
      this.callAlert(
        4,
        "<span style='font-size: 13px;' >Çağrı numarası olmadan aşağıdaki işlemler gerçekleştirilemez.</span> " +
          "<br> " +
          "<span style='font-size: 13px;'>Bu nedenle, işlemlerin gerçekleştirilmesi ve takibi için çağrı numarası gereklidir.</span>" +
          "<br>" +
          "<b style='font-size: 13px;'>IVR ile Ödeme</b>" +
          "<br>" +
          "<b style='font-size: 13px;'>Standart İade</b>" +
          "<br>" +
          "<b style='font-size: 13px;'>Standart Değişiklik</b>",
        "warning",
        "Çağrı Merkezi kullanıcılarının dikkatine:"
      );
    }

    const modalElement = document.getElementById("userMenuModal");
    $(modalElement).on("hidden.bs.modal", this.resetServisCheck);
  },
  methods: {
    handleMouseDownSideBarMenu(event) {
      const sidebar = this.$refs.sidebarMenu?.$el;
      if (sidebar && sidebar.contains(event.target)) {
        this.sideBarMenuClickedInside = true; // Sidebar içi tıklamalar
      } else {
        this.sideBarMenuClickedInside = false; // Dışarı tıklanınca false
      }
    },
    handleClickOutsideSideBarMenu() {
      if (!this.sideBarMenuClickedInside) {
        this.closeSideBar(); // Eğer içeride tıklanmadıysa sidebar kapat
      }
    },
    toggleSidebar() {
      Vue.set(this, "sidebarTransition", this.isOpenSidebar ? "slide-backward" : "slide-forward");
      this.isOpenSidebar = !this.isOpenSidebar;
      this.sideBarMenuClickedInside = !this.sideBarMenuClickedInside;
    },
    closeSideBar() {
      Vue.set(this, "sidebarTransition", "slide-backward");
      this.$nextTick(() => {
        this.isOpenSidebar = false;
        this.sideBarMenuClickedInside = false;
      });
    },
    flattenTree(tree, depth = 0, parentIndex = "") {
      // iç içe yapıları(tree) düz bir dizeye dönüştürme
      let flatList = [];
      // her bir öğeyi dön
      tree.forEach((item, index) => {
        // her biri için bir index oluşturuyoruz front ta
        const itemIndex = parentIndex !== "" ? `${parentIndex}-${index}` : `${index}`;
        // ögeyi ekle
        flatList.push({
          ...item,
          depth, // öğenin derinliği(bu öğenin kök öğeden kaç katman derinlikte olduğunu gösterir.)
          index: itemIndex,
        });
        // Eğer öğenin altında başka alt öğeler (children) varsa, bu alt ögeler için fonksiyonu tekrar çağır
        if (item.children && item.children.length > 0) {
          flatList = flatList.concat(this.flattenTree(item.children, depth + 1, itemIndex));
        }
      });
      return flatList;
    },
    shouldShowItem(item) {
      const query = this.searchQuery.trim().toLocaleLowerCase("tr-TR");
      if (item.name && item.route) {
        return item.name.toLocaleLowerCase("tr-TR").includes(query) && item.route !== "";
      }
      return false;
    },
    hasFavoritesFlat() {
      return (this.$store.getters.getUiFavorites || []).some((f) => this.pagePermissionsMap[f.tag]);
    },
    handleNotificationClick(notification) {
      if (notification.channelName === "KKY" && notification.subject === "Station" && notification.detail === "Create") {
        if (!canCreatePage("/istasyon-tanimlama", this.$store.getters.getUserPermissions)) {
          this.callAlert(6, "Bu işlem için yetkiniz bulunmamaktadır.", "danger", "Yetkisiz İşlem", "danger");
          return;
        }
        this.loadingKKYStationByStationNo = true;
        this.$store
          .dispatch("loadKKYStationByStationNo", { stationNo: notification.extra2 })
          .then((response) => {
            this.loadingKKYStationByStationNo = false;
            this.$store.commit("setSelectedStationFromKKYS", response);
            $("#notificationMenuModal").modal("hide");
            this.$router.push("/istasyon-tanimlama");
          })
          .catch((error) => {
            this.loadingKKYStationByStationNo = false;
            this.callAlert(6, "İşlem gerçekleştirilememektedir.", "danger", "Hata!", "danger");
          })
          .finally(() => {
            this.loadingKKYStationByStationNo = false;
          });
      }
    },
    openNotificationMenuModal() {
      let vm = this;
      $("#notificationMenuModal").modal("show");
      $("#notificationMenuModal").on("hidden.bs.modal", function () {
        vm.deleteAllNotifications();
      });
    },
    fetchNotifications() {
      this.loadingGetNotifications = true;
      this.$store
        .dispatch("getNotifications")
        .then((response) => {
          this.loadingGetNotifications = false;
          response.forEach((notification) => {
            let message = "";
            if (notification.detail === "new") {
              message = `${notification.channelName} tarafında yeni bir istasyon eklendi. : ${notification.extra2} - ${notification.extra1}`;
            } else if (notification.detail === "change") {
              message = `${notification.channelName} tarafında istasyonda değişiklik oldu. : ${notification.extra2} - ${notification.extra1}`;
            }
            // this.callAlert(6,message,"warning","Yeni Bildirim!","warning");
          });

          this.notifications = response;
        })
        .finally(() => {
          this.loadingGetNotifications = false;
        });
    },
    fetchStaffNotifications() {
      this.$store
        .dispatch("fetchStaffNotifications")
        .then((response) => {
          // Bu oturumda zaten gösterilenleri (EVERY_LOGIN/ONCE) ele; modal yalnızca
          // yeni bilgilendirmeler için açılsın. MANDATORY gösterilenler listesine
          // eklenmediğinden onay alınana kadar gelmeye devam eder.
          const shownIds = this.$store.getters.getShownStaffNotificationIds || [];
          const fresh = (response || []).filter((n) => !shownIds.includes(n.id));
          if (fresh.length > 0) {
            this.staffNotifications = fresh;
          }
        })
        .catch(() => {});
    },
    openStaffNotificationHistory() {
      this.$refs.staffNotificationHistoryModal.open();
    },
    openStaffNotificationFromHistory(notifications) {
      this.staffNotifications = notifications || [];
    },
    onStaffNotificationsCompleted() {
      this.staffNotifications = [];
    },
    deleteAllNotifications() {
      for (const notification of this.notifications) {
        this.loadingDeleteUserNotification = true;
        this.$store
          .dispatch("deleteUserNotification", { id: notification.id })
          .then((response) => {
            this.loadingDeleteUserNotification = false;
            if (response) {
              let findIndex = this.notifications.findIndex((x) => x.id === notification.id);
              this.notifications.splice(findIndex, 1);
            }
          })
          .finally(() => {
            this.loadingDeleteUserNotification = false;
          });
      }
    },
    fetchSystemClock() {
      this.intervalSystemClock = setInterval(() => {
        this.loadingSystemDateNow = true;
        this.$store.dispatch("loadSystemDateNow");
        this.loadingSystemDateNow = false;
      }, 300000);
    },
    resetIdleTimer() {
      if (!this.$store.getters.getSessionWarningModalOpen) {
        this.$store.commit("setLastActivityTime", new Date());
      }
    },
    clearStore() {
      this.$store.commit("setDefaultSelectedUser");
      this.$store.commit("setDefaultSelectedUserUnitId");
      this.$store.commit("setDefaultSelectedAgency");
      this.$store.commit("setDefaultSelectedAnnouncement");
      this.$store.commit("setDefaultSelectedAdditionalService");
      this.$store.commit("setDefaultSelectedBlacklistUser");
      this.$store.commit("setDefaultSelectedConnectingTrain");
      this.$store.commit("setDefaultSelectedBoxOffice");
      this.$store.commit("setDefaultSelectedCabinClass");
      this.$store.commit("setDefaultSelectedCar");
      this.$store.commit("setDefaultSelectedDiscountPackage");
      this.$store.commit("setDefaultSelectedFareFamily");
      this.$store.commit("setDefaultSelectedInformation");
      this.$store.commit("setDefaultSelectedItem");
      this.$store.commit("setDefaultSelectedItemProperty");
      this.$store.commit("setDefaultSelectedItemType");
      this.$store.commit("setDefaultSelectedItemGroup");
      this.$store.commit("setDefaultSelectedLine");
      this.$store.commit("setDefaultSelectedMainUnit");
      this.$store.commit("setDefaultSelectedNotification");
      this.$store.commit("setDefaultSelectedOrer");
      this.$store.commit("setDefaultSelectedPassengerType");
      this.$store.commit("setDefaultSelectedQuota");
      this.$store.commit("setDefaultSelectedSchedule");
      this.$store.commit("setDefaultSelectedStation");
      this.$store.commit("setDefaultSelectedSeatMapConnectingTemplate");
      this.$store.commit("setDefaultSelectedRole");
      this.$store.commit("setDefaultSelectedTrainSetMapping");
      this.$store.commit("setDefaultSelectedTrainSet");
      this.$store.commit("setDefaultSelectedSubscription");
      this.$store.commit("setDefaultSelectedSpecialServiceRequest");
      this.$store.commit("setDefaultSelectedSeatMap");
      this.$store.commit("setDefaultSelectedTicketClassRule");
      this.$store.commit("setDefaultSelectedParameter");
      this.$store.commit("setDefaultSelectedResourceGroup");
      // modules start ->
      // this.$store.commit("setDefaultBookingModule");
      // this.$store.commit("setDefaultGiseModule");
      // this.$store.commit("setDefaultPaymentModule");
      this.$store.commit("resetBookingModule");
      this.$store.commit("resetGiseModule");
      this.$store.commit("resetPaymentModule");
      this.$store.commit("setDefaultAdditionalServicePricingModule");
      this.$store.commit("setDefaultAgentModule");
      this.$store.commit("setBookingClassModule");
      this.$store.commit("setDefaultCarModule");
      this.$store.commit("setDefaultCloseAccountModule");
      this.$store.commit("setDefaultAccountApproveModule");
      this.$store.commit("setDefaultCommissionModule");
      this.$store.commit("setDefaultCustomerModule");
      this.$store.commit("setDefaultEquivalentStationModule");
      this.$store.commit("setDefaultTrainWhereStationModule");
      this.$store.commit("setDefaultItemModule");
      this.$store.commit("setDefaultItemGroupTypeModule");
      this.$store.commit("setDefaultItemTypeModule");
      this.$store.commit("setDefaultLineModule");
      this.$store.commit("setDefaultMainUnitModule");
      this.$store.commit("setDefaultOrerModule");
      this.$store.commit("setDefaultParameterModule");
      this.$store.commit("setParkourBasedPricingModule");
      this.$store.commit("setDefaultPassengerTypeModule");
      this.$store.commit("setDefaultPositionModule");
      this.$store.commit("setDefaultPricingModule");
      this.$store.commit("setDefaultQuotaModule");
      this.$store.commit("setDefaultReportModule");
      this.$store.commit("setDefaultResourceModule");
      this.$store.commit("setDefaultResourceGroupModule");
      this.$store.commit("setDefaultRoleModule");
      this.$store.commit("setDefaultSaleChannelModule");
      this.$store.commit("setDefaultSeatMapModule");
      this.$store.commit("setDefaultSeferModule");
      this.$store.commit("setDefaultSegmentModule");
      // this.$store.commit("setDefaultHelperModule");
      this.$store.commit("setDefaultItemGroupModule");
      this.$store.commit("setDefaultKKYAccountTransferModule");
      this.$store.commit("setDefaultTrainSetMappingModule");
      this.$store.commit("setDefaultTimeSchedule");
      this.$store.commit("setDefaultRoleGroupModule");
      this.$store.commit("setDefaultStationStatusModule");
      this.$store.commit("setDefaultStationTypeModule");
      this.$store.commit("setDefaultUserModule");
      // modules end ->
    },
    logOut() {
      try {
        const getUser = this.$store.getters.getUser;
        if (getUser) {
          let logoutRequest = {};
          logoutRequest.accessToken = getUser.accessToken;
          logoutRequest.refreshToken = localStorage.getItem("REFRESH_TOKEN");
          logoutRequest.userId = getUser.userId;
          this.$store.dispatch("userLogout", logoutRequest).then(() => {
            this.clearStoreAndRedirect();
          });
        } else {
          this.clearStoreAndRedirect();
        }
      } catch (e) {
        localStorage.clear();
        if (this.$route.path !== "/giris-yap") {
          this.$router.push("/giris-yap");
        }
      }

      // }
    },
    clearStoreAndRedirect() {
      this.clearStore();
      clearAuthTokens();
      this.loggedIn = false;
      $(".modal").modal("hide");
      window.location = window.location.origin + "/giris-yap";
    },
    getUserName() {
      let name = "User";
      if (this.$store.getters.getUser.firstName !== null) {
        name = this.$store.getters.getUser.firstName[0].toUpperCase() + this.$store.getters.getUser.firstName.slice(1);
      } else if (this.$store.getters.getUser.companyName !== null) {
        name = this.$store.getters.getUser.companyName.split(" ")[0].toLocaleUpperCase("tr-TR");
      }
      return name;
    },
    getFullName() {
      let fullName = "";
      if (this.$store.getters.getUser.firstName !== null) {
        const firstName = this.$store.getters.getUser.firstName.split(" ");
        const lastName = this.$store.getters.getUser.lastName.split(" ");
        for (let i = 0; i < firstName.length; i++) {
          firstName[i] = firstName[i].toLocaleUpperCase("tr-TR");
        }
        for (let i = 0; i < lastName.length; i++) {
          lastName[i] = lastName[i].toLocaleUpperCase("tr-TR");
        }
        fullName = firstName.join(" ") + " " + lastName.join(" ");
      } else if (this.$store.getters.getUser.companyName !== null) {
        fullName = this.$store.getters.getUser.companyName.toLocaleUpperCase("tr-TR");
      }
      return fullName;
    },
    todayDate() {
      return moment(new Date(this.systemDateNow)).locale("tr-TR").format("DD MMMM YYYY");
    },
    dropdownMenuOpen() {
      // dropdown menu açık ise sidebarı kapatıyor
      $(".dropdown").on("show.bs.dropdown", function () {
        // sidebar menüyü kapat start
        const closeBtnSideBarMenu = document.querySelector(".sidebar-menu-wrapper .btnClose");
        if (closeBtnSideBarMenu) {
          closeBtnSideBarMenu.click();
        }
        // sidebar menüyü kapat end
      });
    },
    sidebarMenuCloseButton() {
      // sidebar menüyü kapat start
      const closeBtnSideBarMenu = document.querySelector(".sidebar-menu-wrapper .btnClose");
      if (closeBtnSideBarMenu) {
        closeBtnSideBarMenu.click();
      }
      // sidebar menüyü kapat end
    },
    clickElementBody() {
      const bodyElement = document.querySelector("body");
      if (bodyElement) {
        bodyElement.click();
      }
    },
    navigateDropdown(event) {
      if (event.key === "Escape") {
        this.searchMenuDropdownOpen = false;
        // input focus kaldırır
        const activeElement = document.activeElement;
        if (activeElement) {
          activeElement.blur();
        }
        // dropdown kapanması için
        const bodyElement = document.querySelector("body");
        if (bodyElement) {
          bodyElement.click();
        }
        return;
      }
      if (event.key === "Enter") {
        const activeItem = document.querySelector(".dropdown-menu .navbarSearch ul li.active");
        if (activeItem) {
          let aElement = activeItem.querySelector("a");
          const reportsIdPrefix = "report-";
          // <a> elementinin href özelliğine eriş
          let href = aElement.getAttribute("href");

          // aynı sayfaya route etmek istenildiğinde işlemin olmaması için
          if (this.$route.path !== href && href) {
            this.$router.push(href);
            this.searchQuery = "";
            const activeElement = document.activeElement;
            activeElement.blur();
            this.searchMenuDropdownOpen = false;
          } else if (href === null && document.querySelectorAll(`[id^="${reportsIdPrefix}"]`)) {
            // aşağıdaki reportId elementin idsine setlene reportId sini yakalamak için yazılmıştır.
            let reportId = aElement.id.substring(reportsIdPrefix.length);
            if (reportId) {
              this.loadingReport = true;
              this.$store
                .dispatch("loadReport", { id: reportId })
                .then(() => {
                  this.loadingReport = false;
                  if (!this.$route.path.startsWith("/rapor-sayfasi")) {
                    this.$router.push(`/rapor-sayfasi/${reverseReportMap[reportId]}`);
                    this.searchQuery = "";
                    const activeElement = document.activeElement;
                    activeElement.blur();
                    this.searchMenuDropdownOpen = false;
                  }
                })
                .finally(() => {
                  this.loadingReport = false;
                });
            }
          }
        }
        return;
      }
      this.serchArea = false;
      // yön tuşları keydown
      let dropdownItems = Array.from(document.querySelectorAll(".dropdown-menu .navbarSearch ul li"));
      let currentIndex = dropdownItems.findIndex((item) => item.classList.contains("active"));

      if (currentIndex === -1) {
        currentIndex = 0;
        // burda ilk başta seçili oge olmayacak seçili öge olmadığı için class eklemeyecek.
        if (event.key === "ArrowDown") {
          dropdownItems.forEach((item) => item.classList.remove("active"));
          dropdownItems[currentIndex].classList.add("active");
          dropdownItems[currentIndex].scrollIntoView({ behavior: "smooth", block: "nearest" });
        } else if (event.key === "ArrowUp") {
          currentIndex = dropdownItems.length - 1;
          dropdownItems.forEach((item) => item.classList.remove("active"));
          dropdownItems[currentIndex].classList.add("active");
          dropdownItems[currentIndex].scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      } else {
        if (event.key === "ArrowUp") {
          currentIndex = currentIndex <= 0 ? dropdownItems.length - 1 : currentIndex - 1;
        } else if (event.key === "ArrowDown") {
          currentIndex = currentIndex >= dropdownItems.length - 1 ? 0 : currentIndex + 1;
        }
        dropdownItems.forEach((item) => item.classList.remove("active"));
        dropdownItems[currentIndex].classList.add("active");
        dropdownItems[currentIndex].scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    },
    removeDropdownActiveClass() {
      // Dropdown menü dışına tıklandığında seçili(active class) öğeyi temizleme (beforeDestroy kaldırır)
      this._dropdownActiveClassHandler = (event) => {
        // favori işlemleri kapatıp search area alanını açıyor
        let dropdownMenu = document.querySelector(".headerSearchDropdown .dropdown-menu");

        if (dropdownMenu) {
          if (!event.target.closest(".dropdown") && event.target !== dropdownMenu) {
            const dropdownItems = Array.from(dropdownMenu.querySelectorAll("li"));
            dropdownItems.forEach((item) => item.classList.remove("active"));

            // sıfırsa favori div göster
            if (this.searchQuery.length === 0) {
              this.serchArea = true;
            } else {
              this.serchArea = false;
            }
            this.hasFavoritesFlat();
          }
        }
      };
      document.addEventListener("click", this._dropdownActiveClassHandler);
    },
    dropdownMenuScroll() {
      // dropdown menu kendi içinde scroll olması (beforeDestroy kaldırır)
      this._dropdownMenuScrollHandler = (event) => {
        const dropdownOpen = document.querySelector(".dropdown.show");
        if (!dropdownOpen) return;

        const focusedElement = document.activeElement;
        const dropdownMenu = dropdownOpen.querySelector(".dropdown-menu");
        const dropdownItems = [];
        if (dropdownMenu) {
          Array.from(dropdownMenu.querySelectorAll("a"));
        }

        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
          event.preventDefault();
          if (focusedElement === dropdownMenu || dropdownItems.includes(focusedElement)) {
            const direction = event.key === "ArrowUp" ? "up" : "down";
            this.navigateDropdown(direction);
          }
        }
      };
      document.addEventListener("keydown", this._dropdownMenuScrollHandler);
    },
    // YTP-10521 mobil arama breakpoint'i (searchBtn <=576px'te; .show'u yalnizca mobilde Vue verir)
    updateMobileSearch() {
      this.isMobileSearch = !!(this._mobileSearchMq && this._mobileSearchMq.matches);
    },
    mobileSearchButton() {
      this.searchMenuDropdownOpen = !this.searchMenuDropdownOpen;
      // click olduğu anda dom üzerinden eleman daha gözükmediği için (setTimeout)
      setTimeout(() => {
        document.querySelector(".headerMenuArea .headerArea .searchInputMobil").focus();
      });
    },
    searchMenuToggleDropdown() {
      this.searchMenuDropdownOpen = !this.searchMenuDropdownOpen;
    },
    searchMenuDropdownHandleClickOutside(event) {
      const dropdown = this.$refs.searchMenuDropdownRef;
      if (dropdown && !dropdown.contains(event.target)) {
        this.searchMenuDropdownOpen = false;
      }
    },
    setTitlesBasedOnPermissions() {
      this.pagePermissionsMap = {};
      const permissions = this.$store.getters.getUserResources.map((resource) => resource.tag);
      permissions.forEach((element) => {
        this.pagePermissionsMap[element] = element;
      });
      this.flatItems.filter((item) => permissions.includes(item.pagePermissionTag));
    },
    checkForSameRoute(path) {
      this.lastOpenedSideBarContent = path;
      if (this.$router.currentRoute.path === path) {
        this.loadingSamePage = true;
        setTimeout(() => {
          this.loadingSamePage = false;
        }, 500);
      }
      // sidebar menüyü kapat start
      const closeBtnSideBarMenu = document.querySelector(".sidebar-menu-wrapper .btnClose");
      if (closeBtnSideBarMenu) {
        closeBtnSideBarMenu.click();
      }
      // sidebar menüyü kapat end
    },
    allMenuList() {
      this.filteredItems = [...enumHelper.allMenuList];
      this.originalItems = JSON.parse(JSON.stringify(this.filteredItems));
    },
    goToReportPage(item) {
      if (item.reportId) {
        this.loadingReportPage = true;
        this.$store
          .dispatch("loadReport", { id: item.reportId })
          .then(() => {
            this.loadingReportPage = false;
            // if (!this.$route.path.startsWith("/rapor-sayfasi")) {
            //   this.$router.push("/rapor-sayfasi");
            //   this.$router.push({ path: "/rapor-sayfasi/" + reverseReportMap[item.reportId] });
            // }
            this.searchQuery = "";
            this.serchArea = !this.serchArea;
            this.$router.push({ path: "/rapor-sayfasi/" + reverseReportMap[item.reportId] });
          })
          .finally(() => {
            this.loadingReportPage = false;
          });
      }
    },
    searchInputReset() {
      // this.filteredItems = JSON.parse(JSON.stringify(this.originalItems));
      // this.flatItems = JSON.parse(JSON.stringify(this.originalItems));
      this.searchQuery = "";
      this.serchArea = !this.serchArea;
      this.searchMenuDropdownOpen = false;
    },
    // YTP-10380 Favoriler store'da kalici. Tag ile toggle; yildiz/durum isFav ile reaktif gelir.
    favoriteItem(item) {
      const tag = item && item.pagePermissionTag;
      if (!tag) return;
      const favorites = [...(this.$store.getters.getUiFavorites || [])];
      const idx = favorites.findIndex((f) => f.tag === tag);
      if (idx === -1) {
        favorites.push({ tag, name: item.name, route: item.route, reportId: item.reportId || null });
      } else {
        favorites.splice(idx, 1);
      }
      this.$store.dispatch("saveUiSettings", { favorites });
    },
    isFav(item) {
      return (this.$store.getters.getUiFavorites || []).some((f) => f.tag === (item && item.pagePermissionTag));
    },
    preventDropdownClose(event) {
      event.stopPropagation();
    },
    loadReport(id) {
      // this.loadingReportId = true;
      // this.$store.dispatch("loadReport", { id });
      // this.loadingReportId = false;
      this.goToReportPage({ reportId: id });
      // sayfa geçişlerinde sidebar menüyü kapat start
      const closeBtnSideBarMenu = document.querySelector(".sidebar-menu-wrapper .btnClose");
      if (closeBtnSideBarMenu) {
        closeBtnSideBarMenu.click();
      }
      // sayfa geçişlerinde sidebar menüyü kapat end
    },
    activeDropdownUnitItemClass(userUnit) {
      return this.selectedUserUnitId === userUnit.id;
    },
    activeDropdownUnitItem(unit) {
      // this.activeDropdownUserUnit = unit;
      this.changeUnit(unit);
    },
    changeUnit(unit) {
      $("#userMenuModal").modal("hide");
      //this.$store.commit("setLoggedIn", false);
      let checkOpenAccountRequest = {};
      checkOpenAccountRequest.salesUserId = this.$store.getters.getUser.userId;
      checkOpenAccountRequest.unitId = unit.id;
      checkOpenAccountRequest.salesChannelId = this.userUnitsMap[unit.id].salesChannel;
      this.loadingCheckOpenAccount = true;
      this.$store.dispatch("checkOpenAccount", checkOpenAccountRequest).then((responseCheckOpenAccount) => {
        this.loadingCheckOpenAccount = false;
        if (responseCheckOpenAccount.status === 200) {
          this.selectedUserUnitId = unit.id;
          this.selectedUnitId = this.selectedUserUnitId;
          this.$store.commit("setUserResources", []);
          this.isOpenAccount = responseCheckOpenAccount.data.openAccount;
          this.$store.commit("setAutoCloseShown", responseCheckOpenAccount.data.autoCloseShown);
          if (!this.$store.getters.getAutoCloseShown) {
            this.$store.commit("setInformationForAutoClosePopUp", responseCheckOpenAccount.data);
          }
          if (this.isOpenAccount) {
            this.selectedUserUnitId = responseCheckOpenAccount.data.unitId;
            this.selectedUnitId = this.selectedUserUnitId;
          }

          // localStorage.setItem("UNIT_ID", this.selectedUnitId);
          axios.defaults.headers.common["unit-id"] = this.selectedUnitId;
          this.loadingParametersByUnit = true;
          const requestParameters = this.selectedUnitId;
          this.loadingParametersByUnit = true;
          this.$store
            .dispatch("parametersByUnit", requestParameters)
            .then((response) => {
              this.loadingParametersByUnit = false;
              if (response.data.code === 0) {
                this.callAlert(4, response.data.message, "danger", "İşlem Hatası");
                this.logOut();
                return;
              } else {
                this.loadingParametersByUnit = false;
                this.$store.commit("setParametersByUnit", response.data);

                let request = {};
                request.accessToken = localStorage.getItem("AUTH_TOKEN");
                request.unitId = this.selectedUnitId;
                this.loadingAuthorizeByUnit = true;
                this.$store
                  .dispatch("authorizeByUnit", request)
                  .then((response) => {
                    this.loadingAuthorizeByUnit = false;
                    // Yetkiler alınamazsa önceki birimin yetkileriyle devam edilmez, oturum kapatılır.
                    if (!response || !Array.isArray(response.resources)) {
                      this.callAlert(4, "Yetkileriniz alınamadı. Lütfen tekrar giriş yapınız.", "danger", "İşlem Hatası");
                      this.logOut();
                      return;
                    }
                    this.$store.commit("setUserResources", response.resources);
                    this.$store.commit(
                      "setUserPermissions",
                      response.resources.map((resource) => resource.tag)
                    );
                    this.$store.commit("setAssociatedStationId", response.associatedStationId);
                    //this.$store.commit("setLoggedIn", true);
                    this.createdFunction();
                    if (this.isOpenAccount) {
                      if (this.$route.path !== "/personel-hesap-kapatma") {
                        this.$router.push("/personel-hesap-kapatma");
                      }
                    } else {
                      window.location.href = window.location.origin + "/";
                    }
                  })
                  .finally(() => {
                    this.loadingParametersByUnit = false;
                    this.loadingAuthorizeByUnit = false;
                  });
              }
            })
            .catch(() => {
              this.callAlert(4, "İşlem Hatası", "danger", "İşlem Hatası");
              this.logOut();
              return;
            })
            .finally(() => {
              this.loadingParametersByUnit = false;
            });
        } else {
          this.callAlert(4, "Açık Hesap kontrolü başarısız.", "danger", "Başarısız.", "danger");
        }
      });
    },
    selectedUserUnits(unitType) {
      this.userUnits = this.$store.getters.getUser.userUnits;
      if (Object.keys(this.userUnitsMap).length === 0) return "Tanımsız";
      let unitTypeName = "";
      switch (unitType) {
        case "STATION":
          unitTypeName = "İstasyon Görevlisi";
          break;
        case "BOX_OFFICE":
          unitTypeName = "Gişe Görevlisi";
          break;
        case "AGENCY":
          unitTypeName = "Acente Görevlisi";
          break;
        case "CALL_CENTER":
          unitTypeName = "Çağrı Merkezi Görevlisi";
          break;
        case "GENERIC_UNIT":
          unitTypeName = "Ana Birim Görevlisi";
          break;
      }
      return unitTypeName;
    },
    createdFunction() {
      if (this.selectedUnitId === null || this.selectedUnitId === undefined) {
        // this.selectedUnitId = Number(localStorage.getItem("UNIT_ID"));
        this.selectedUnitId = this.$store.getters.getSelectedUserUnitId;
      }
      this.setUserUnitsMap();
      // this.selectedUserUnits();
    },
    setUserUnitsMap() {
      let userUnits = this.$store.getters.getUser.userUnits || [];
      this.userUnitsMap = userUnits.reduce(function (map, unit) {
        map[unit.id] = unit;
        return map;
      }, {});
    },
    fetchServisCheck() {
      if (!this.servisCheckStatus) {
        this.loadingServisCheck = true;
        this.servisCheckStatus = true;
        this.$store
          .dispatch("servisCheck")
          .then((response) => {
            if (response.status === 200) {
              this.servisCheck = response.data[0];
              this.servisCheckStatus = true;
            } else {
              this.resetServisCheck();
              this.callAlert(4, "Servis kontrolü başarısız.", "danger", "Başarısız.", "danger");
            }
          })
          .catch(() => {
            this.resetServisCheck();
            this.callAlert(4, "Servis kontrolü başarısız.", "danger", "Başarısız.", "danger");
          })
          .finally(() => {
            this.loadingServisCheck = false;
          });
      } else {
        this.resetServisCheck();
      }
    },
    resetServisCheck() {
      this.servisCheck = { mernisStatus: null, disabledCardStatus: null, kkyTasimacilikStatus: null, kkyAltyapiStatus: null };
      this.servisCheckStatus = false;
    },
    fetchPriceExchangeWithMultiplier() {
      if (!this.getPriceExchangeWithMultiplierStatus) {
        this.loadingGetPriceExchangeWithMultiplier = true;
        this.getPriceExchangeWithMultiplierStatus = true;
        this.$store
          .dispatch("getPriceExchangeWithMultiplier")
          .then((response) => {
            this.priceExchangeWithMultipliers = response;
            this.priceExchangeWithMultipliers.formattedDate = moment(this.priceExchangeWithMultipliers.date, "MM/DD/YYYY").format("DD/MM/YYYY");
            this.getPriceExchangeWithMultiplierStatus = true;
          })
          .catch(() => {
            this.callAlert(4, "Beklenmeyen bir hata oluştu", "danger", "Başarısız.", "danger");
          })
          .finally(() => {
            this.loadingGetPriceExchangeWithMultiplier = false;
          });
      } else {
        this.getPriceExchangeWithMultiplierStatus = false;
      }
    },
  },
  // watch:{
  //   "loggedIn":{
  //     handler(newValue, oldValue) {
  //       if(oldValue && !newValue){
  //         this.logOut()
  //       }
  //     },
  //   }
  // }
};
</script>

<style lang="scss" scoped>
//içeri alınacak
.headerArea .headerNav .navbarSearch {
  height: 412px;
}

.sideNav {
  padding-top: unset !important;
}

.headerArea .headerNav .FavoriteTrades {
  height: 100%;
  padding-bottom: 0px;
  padding-top: 0px;

  @media (max-width: 575px) {
    height: 0;
  }

  .favoriteTradesRow {
    padding-top: 30px;
  }
}

.headerArea .headerNav .FavoriteTrades ul li a {
  text-align: left;
}

.headerArea .headerNav .FavoriteTrades .FavoriteTradesTitle {
  margin-bottom: 15px;
}

/* YTP-10380 favori yildizi altin/sari */
.favStarGold {
  filter: invert(78%) sepia(69%) saturate(560%) hue-rotate(358deg) brightness(102%) contrast(97%);
}

.tooltipContainer {
  opacity: 1 !important;

  .tooltip-inner {
    text-align: left;
  }
}

.userArea {
  .userInformation {
    margin: 0px;
    padding: 24px 24px 20px 24px;

    img {
      border: 0px;
      margin: 0px;
      border-radius: 0px;
      width: auto;
      height: auto;
    }

    .userImgArea {
      position: relative;

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 8px;
        height: 8px;
        background-color: #28c459;
        border-radius: 50%;
        top: 23px;
        right: -3px;
        outline: 3px solid white;
      }

      img {
        width: 120px;
        height: 120px;
        object-fit: contain;
        border-radius: 8px;
      }
    }

    h5 {
      font-weight: bold;
      color: #183153;
      line-height: normal;
      margin-bottom: 15px;
      margin-top: 15px;
      text-align: left;
    }

    .unitInfoArea {
      border-radius: 8px;
      border: dashed 1px #bcbfd0;
      padding: 5px 8px;

      ::v-deep {
        .dropdownCheck {
          vertical-align: top;
          display: block;

          .dropdown-toggle {
            font-size: 12px;
            font-weight: 500;
            color: var(--bluish-green);

            img {
              width: auto;
              height: auto;
              object-fit: none;
              margin-right: 4px;
            }
          }

          .dropdown-menu {
            border-radius: 8px;
          }
        }
      }

      .textGrey {
        font-size: 12px;
        font-weight: 500;
        letter-spacing: -0.06px;
        color: var(--blue-grey);
        margin-bottom: 0px;
        line-height: normal;
      }

      .textUnitName {
        font-size: 13px;
        font-weight: bold;
        line-height: normal;
        color: #183153;
        margin-top: 4px;
        margin-bottom: 6px;
      }
    }

    .taskArea {
      text-align: left;
      margin-top: 15px;

      .textHead {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: -0.07px;
        color: var(--blue-grey);
        line-height: normal;
        margin-bottom: 4px;
        display: flex;
        align-items: center;

        img {
          margin-right: 8px;
        }
      }

      .text {
        font-size: 12px;
        font-weight: 500;
        letter-spacing: -0.06px;
        color: var(--blue-grey);
        line-height: normal;
        margin-bottom: 4px;

        img {
          margin-right: 4px;
        }
      }
    }
  }
}

.headerMenuArea {
  .ucidArea {
    position: relative;
    display: flex;
    justify-content: center;

    .ucidCode {
      position: fixed;
      top: 0;
      z-index: 101;
      border-radius: 0 0 12px 12px;
      background-color: #f73a5e;
      display: flex;
      align-items: center;
      padding: 1px 14px 1px 8px;

      @media (max-width: 767px) {
        bottom: 0;
        top: auto;
        border-radius: 12px 12px 0 0;
      }

      img {
        width: 37px;
        height: 37px;

        @media (max-width: 992px) {
          width: 22px;
          height: 22px;
        }
      }

      .text {
        font-size: 16px;
        font-weight: bold;
        color: var(--white);
        line-height: normal;

        @media (max-width: 992px) {
          font-size: 14px;
        }
      }
    }
  }

  .sync-alt-icon {
    padding-right: 12px;
  }

  .status-circle {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 8px;
    color: white;
    font-size: 12px;
  }

  .bg-green {
    background-color: #27c459;
  }

  .bg-red {
    background-color: #fc4758;
  }

  .bg-gray {
    background-color: #a3a3a3;
  }

  .services-container {
    padding: 10px 15px;
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-top: 10px;
  }
  .sidebarMenuArea {
    width: 372px;
    .slide-forward-enter-active {
      transition: transform 0.5s ease-in-out;
    }

    .slide-forward-leave-active {
      transition: transform 0.3s ease-in-out;
    }

    .slide-forward-enter {
      transform: translateX(-100%);
    }

    .slide-forward-leave-to {
      transform: translateX(100%);
    }

    .slide-backward-enter-active {
      transition: transform 0.5s ease-in-out;
    }

    .slide-backward-leave-active {
      transition: transform 0.3s ease-in-out;
    }

    .slide-backward-enter {
      transform: translateX(100%);
    }

    .slide-backward-leave-to {
      transform: translateX(-100%);
    }
  }
}
</style>
